export default {
  LegacyNotification: 8000,
  DefaultNotification: 1000,
  DefaultSuccessNotification: 1000,
  DefaultInfoNotification: 1000,
  DefaultWarningNotification: 2000,
  DefaultErrorNotification: 2000,
};
